<template>
  <div class="mision">
    <router-link
      to="/progreso"
      class="miperfil abs pointer"
      data-aos="fade-right"
      data-aos-delay="200"
    >
      <img
        src="../../assets/imgs/mision/btn-mi-perfil.png"
        alt="Encauce"
        class="img-fluid"
      />
    </router-link>

    <section class="pantalla mision1_3">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 contentabs">
            <div class="logo abs" data-aos="fade-down" data-aos-delay="200">
              <img
                src="../../assets/imgs/encauce-logo-blanco-stem.png"
                alt="Encauce"
                class="img-fluid"
              />
            </div>

            <div class="diagrama">
              <img
                src="../../assets/imgs/universos/diagrama.png"
                alt="Encauce"
                class="img-fluid bgdiagrama"
              />

              <a
                href="https://www.google.com/search?q=estudia+derecho&oq=estudia+derecho"
                target="_blank"
                class="opcion opcion1"
              >
                <img
                  src="../../assets/imgs/universos/btn-filtro.png"
                  alt="Encauce"
                  class="img-fluid"
                />
                <div class="texto fpG azuloscuro">
                  PROFESIONALES
                </div>
              </a>

              <a
                href="https://www.google.com/search?q=estudia+derecho&oq=estudia+derecho"
                target="_blank"
                class="opcion opcion2"
              >
                <img
                  src="../../assets/imgs/universos/btn-filtro.png"
                  alt="Encauce"
                  class="img-fluid"
                />
                <div class="texto fpG azuloscuro">
                  TSU
                </div>
              </a>

              <a
                href="https://www.google.com/search?q=estudia+derecho&oq=estudia+derecho"
                target="_blank"
                class="opcion opcion3"
              >
                <img
                  src="../../assets/imgs/universos/btn-filtro.png"
                  alt="Encauce"
                  class="img-fluid"
                />
                <div class="texto fpG azuloscuro">
                  TÉCNICAS
                </div>
              </a>

              <a
                href="https://www.google.com/search?q=estudia+derecho&oq=estudia+derecho"
                target="_blank"
                class="opcion opcion4"
              >
                <img
                  src="../../assets/imgs/universos/btn-filtro.png"
                  alt="Encauce"
                  class="img-fluid"
                />
                <div class="texto fpG azuloscuro">
                  PRESENCIAL
                </div>
              </a>

              <a
                href="https://www.google.com/search?q=estudia+derecho&oq=estudia+derecho"
                target="_blank"
                class="opcion opcion5"
              >
                <img
                  src="../../assets/imgs/universos/btn-filtro.png"
                  alt="Encauce"
                  class="img-fluid"
                />
                <div class="texto fpG azuloscuro">
                  ESENCIAL
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import AOS from "aos";
import swal from "sweetalert2";
import router from "../../router/index";

export default {
  components: {
    Footer,
  },
  data() {
    return {
      loginForm: {
        email: "",
        password: "",
      },
      settings: {
        personaje: null,
        mision: 1,
      },
      showLoginForm: true,
      showPasswordReset: false,
      showMonedero: false,
      dateType: "text",
      res: -1,
      oraculo: false,
      resultado: false,
      time: 0,
      mision: 1,
      reto: 3,
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });

  },
  methods: {
    avanzar() {
      this.$router.push("/universos/");
    },
    async setAvance() {
      let data = {
        index_mision: this.mision - 1,
        write: { mision: this.mision, reto: this.reto + 1, total: 4 },
      };

      await this.$store.dispatch("setAvance", data);
    },

    siguienteMision() {
      this.$router.push("/mision-1-4");
    },
    toggleOraculo() {
      this.oraculo = !this.oraculo;
    },
  },
};
</script>

<style lang="scss" scoped>
.mision {
  background: #674edd;
  .contentabs {
    .logo {
      top: 2%;
      right: 5%;
      width: 10%;
      position: absolute;
    }
    .titulo {
      position: absolute;
      left: 29%;
      width: 40%;
      top: 0%;
    }
  }
}

.mision1_3 {
  background: url(../../assets/imgs/universos/bg-filtros.jpg) no-repeat;
  background-size: contain;
  background-position: center center;

  .diagrama {
    position: absolute;
    width: 100%;
    top: 45%;
    transform: translateY(-50%);
    left: 30%;
    .bgdiagrama {
      width: 40%;
    }

    .opcion {
      position: absolute;
      width: 18%;
      text-align: center;
      cursor: pointer;
      font-weight: bold;
      .texto{
        position:absolute;
        top:25%;
        width: 100%;
        text-align: center;
      }
    }

    .opcion1 {
      top: 60%;
      left: -9%;
    }

    .opcion2 {
      top: 60%;
      left: 11%;
    }

    .opcion3 {
      top: 60%;
      left: 31%;
    }

    .opcion4 {
      top: 100%;
      left: 2%;
    }

    .opcion5 {
      top: 100%;
      left: 20%;
    }

  }
}
</style>